import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog'
import { Button } from '@/components/ui/button'
import { Trophy, Download } from 'lucide-react'
import type { Ganador } from '../types/sorteos.types'

interface WinnersModalProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  ganadores: Ganador[]
  onDescargar: () => void
  sorteoNombre: string
}

export function WinnersModal({ open, onOpenChange, ganadores, onDescargar, sorteoNombre }: WinnersModalProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-lg">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <Trophy className="h-5 w-5 text-teal-500" />
            Ganadores - {sorteoNombre}
          </DialogTitle>
        </DialogHeader>

        <div className="space-y-3 max-h-96 overflow-y-auto">
          {ganadores.length === 0 ? (
            <p className="text-center text-muted-foreground py-8">No hay ganadores aún</p>
          ) : (
            ganadores.map((g) => (
              <div
                key={g.id}
                className="flex items-center gap-3 p-3 rounded-lg border border-gray-200 dark:border-gray-700"
              >
                <div className="flex items-center justify-center w-8 h-8 rounded-full bg-teal-500/10 text-teal-700 dark:text-teal-300 font-bold text-sm">
                  {g.posicion}
                </div>
                <div className="flex-1">
                  <p className="font-medium">{g.nombre}</p>
                  {g.correo && <p className="text-sm text-muted-foreground">{g.correo}</p>}
                  {g.texto_ganado && (
                    <p className="text-sm text-teal-600 dark:text-teal-400">Premio: {g.texto_ganado}</p>
                  )}
                </div>
                {g.pais && (
                  <span className="text-sm text-muted-foreground">{g.pais}</span>
                )}
              </div>
            ))
          )}
        </div>

        {ganadores.length > 0 && (
          <div className="flex justify-end pt-2">
            <Button variant="outline" onClick={onDescargar}>
              <Download className="h-4 w-4 mr-2" />
              Descargar Excel
            </Button>
          </div>
        )}
      </DialogContent>
    </Dialog>
  )
}
